/**
 * APIL Url: ADAC.Internet.Interfaces.AnredeArt
 * Anrede für Personen, Werte: None = 0; Herr = 1; Frau = 2; Familie = 3; Firma = 4; Unbekannt = 9; 
 */
export enum AnredeArtApi {
	None = 0,  // None
	Herr = 1,  // Herr
	Frau = 2,  // Frau
	Familie = 3,  // Familie
	Firma = 4,  // Firma
	Unbekannt = 9  // Unbekannt
};